import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-taxonomy-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './taxonomy-button.component.html',
  styleUrl: './taxonomy-button.component.scss',
})
export class TaxonomyButtonComponent {
  @Input() buttonText: string = '';
  @Input() iconUrl: string = '';
  @Output() onButtonClick = new EventEmitter<void>();
  @Input() Color?: string = '';
  @Input() backgroundColor?: string = '';
  @Input() disabled?: boolean = false;
  @Input() updateButtonStyle?: boolean = false;
  @Input() clicked?: boolean = false;
  @Input() flexDirection?: string = 'row';

  handleButtonClick = (event: MouseEvent) => {
    if (this.onButtonClick) {
      this.onButtonClick.emit();
    }
    event?.stopPropagation();
  };
}
